import { Navigate, useLocation, useParams } from 'react-router-dom';

interface LegacyPrefixRedirectProps {
  /** Absolute destination prefix, e.g. `/security/incidents`. */
  to: string;
}

/**
 * Redirects a legacy top-level path — and every path nested under it — to its
 * relocated `/security/*` counterpart, preserving the remaining sub-path, query
 * string and hash (VIS-197).
 *
 * Wired in `App.tsx` against a splat route (`<Route path="incidents/*" />`), so
 * `/incidents` → `/security/incidents`, `/incidents/:id` → `/security/incidents/:id`,
 * and `/threats/feeds/manage` → `/security/threats/feeds/manage` all keep working
 * for existing bookmarks.
 */
export function LegacyPrefixRedirect({ to }: LegacyPrefixRedirectProps) {
  const params = useParams();
  const { search, hash } = useLocation();

  // `*` is the splat captured by the parent `<Route path="<from>/*">`.
  const rest = params['*'];
  const target = rest ? `${to}/${rest}` : to;

  return <Navigate to={`${target}${search}${hash}`} replace />;
}

export default LegacyPrefixRedirect;
